import { bannerData } from "../../../globals/banner";
import Banner from "../../sections/common/banner";

function IconsPage() {
    return (
        <>
            <Banner _data={bannerData.icons} />

            <div className="section-full p-t100 p-b70 mobile-page-padding">
                <div className="container">
                    <div className="section-content">
                        <div className="sx-box m-b30">
                            <div className="icon-font">
                                <div className="icon-font-block"><div className="flat-icon flaticon-twitter" />
                                    <div className="class-name">.flaticon-twitter</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-facebook" />
                                    <div className="class-name">.flaticon-facebook</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-instagram" />
                                    <div className="class-name">.flaticon-instagram</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-linkedin" />
                                    <div className="class-name">.flaticon-linkedin</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-youtube" />
                                    <div className="class-name">.flaticon-youtube</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-behance" />
                                    <div className="class-name">.flaticon-behance</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-rss" />
                                    <div className="class-name">.flaticon-rss</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-dribbble" />
                                    <div className="class-name">.flaticon-dribbble</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-left-chevron" />
                                    <div className="class-name">.flaticon-left-chevron</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-chevron" />
                                    <div className="class-name">.flaticon-chevron</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-long-arrow-pointing-to-the-right" />
                                    <div className="class-name">.flaticon-long-arrow-pointing-to-the-right</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-long-arrow-pointing-to-left" />
                                    <div className="class-name">.flaticon-long-arrow-pointing-to-left</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-play-button" />
                                    <div className="class-name">.flaticon-play-button</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-play" />
                                    <div className="class-name">.flaticon-play</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-security" />
                                    <div className="class-name">.flaticon-security</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-employee" />
                                    <div className="class-name">.flaticon-employee</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-smart-contracts" />
                                    <div className="class-name">.flaticon-smart-contracts</div>
                                </div>
                                {/*New*/}
                                <div className="icon-font-block"><div className="flat-icon flaticon-maps-and-flags" />
                                    <div className="class-name">.flaticon-maps-and-flags</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-email-1" />
                                    <div className="class-name">.flaticon-email-1</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-incoming-call" />
                                    <div className="class-name">.flaticon-incoming-call</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-monitor" />
                                    <div className="class-name">.flaticon-monitor</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-mouse-1" />
                                    <div className="class-name">.flaticon-mouse-1</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-layers" />
                                    <div className="class-name">.flaticon-layers</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-web-design" />
                                    <div className="class-name">.flaticon-web-design</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-check-mark" />
                                    <div className="class-name">.flaticon-check-mark</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-wordpress" />
                                    <div className="class-name">.flaticon-wordpress</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-wordpress-1" />
                                    <div className="class-name">.flaticon-wordpress-1</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-calendar" />
                                    <div className="class-name">.flaticon-calendar</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-category" />
                                    <div className="class-name">.flaticon-category</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-leaf" />
                                    <div className="class-name">.flaticon-leaf</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-image" />
                                    <div className="class-name">.flaticon-image</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-search" />
                                    <div className="class-name">.flaticon-search</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-up-right-arrow" />
                                    <div className="class-name">.flaticon-up-right-arrow</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-telephone" />
                                    <div className="class-name">.flaticon-telephone</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-phone" />
                                    <div className="class-name">.flaticon-phone</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-email" />
                                    <div className="class-name">.flaticon-email</div>
                                </div>
                                {/*New*/}
                                <div className="icon-font-block"><div className="flat-icon flaticon-computer-hardware" />
                                    <div className="class-name">.flaticon-computer-hardware</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-mouse" />
                                    <div className="class-name">.flaticon-mouse</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-download" />
                                    <div className="class-name">.flaticon-download</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-cloud-computing" />
                                    <div className="class-name">.flaticon-cloud-computing</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-chart" />
                                    <div className="class-name">.flaticon-chart</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-data" />
                                    <div className="class-name">.flaticon-data</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-programmer" />
                                    <div className="class-name">.flaticon-programmer</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-survey" />
                                    <div className="class-name">.flaticon-survey</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-positive-review" />
                                    <div className="class-name">.flaticon-positive-review</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-profit" />
                                    <div className="class-name">.flaticon-profit</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-engineer" />
                                    <div className="class-name">.flaticon-engineer</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-parking" />
                                    <div className="class-name">.flaticon-parking</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-up-arrow" />
                                    <div className="class-name">.flaticon-up-arrow</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-quote" />
                                    <div className="class-name">.flaticon-quote</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-back-left" />
                                    <div className="class-name">.flaticon-back-left</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-quotation-mark" />
                                    <div className="class-name">.flaticon-quotation-mark</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-email-2" />
                                    <div className="class-name">.flaticon-email-2</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-map-location" />
                                    <div className="class-name">.flaticon-map-location</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-clock" />
                                    <div className="class-name">.flaticon-clock</div>
                                </div>
                                {/*New*/}
                                <div className="icon-font-block"><div className="flat-icon flaticon-technical-support" />
                                    <div className="class-name">.flaticon-technical-support</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-mouse" />
                                    <div className="class-name">.flaticon-mouse</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-consultant" />
                                    <div className="class-name">.flaticon-consultant</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-touch" />
                                    <div className="class-name">.flaticon-touch</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-monitor-1" />
                                    <div className="class-name">.flaticon-monitor-1</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-laptop" />
                                    <div className="class-name">.flaticon-laptop</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-laptop-1" />
                                    <div className="class-name">.flaticon-laptop-1</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-support" />
                                    <div className="class-name">.flaticon-support</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-technology" />
                                    <div className="class-name">.flaticon-technology</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-responsive" />
                                    <div className="class-name">.flaticon-responsive</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-coding" />
                                    <div className="class-name">.flaticon-coding</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-web-programming" />
                                    <div className="class-name">.flaticon-web-programming</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-coding-1" />
                                    <div className="class-name">.flaticon-coding-1</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-app-development" />
                                    <div className="class-name">.flaticon-app-development</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-growth" />
                                    <div className="class-name">.flaticon-growth</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-software-development" />
                                    <div className="class-name">flaticon-software-development</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-web-development" />
                                    <div className="class-name">.flaticon-web-development</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-promotion" />
                                    <div className="class-name">.flaticon-promotion</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-supply-chain" />
                                    <div className="class-name">.flaticon-supply-chain</div>
                                </div>
                                {/*New*/}
                                <div className="icon-font-block"><div className="flat-icon flaticon-development" />
                                    <div className="class-name">.flaticon-development</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-skills" />
                                    <div className="class-name">.flaticon-skills</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-improve" />
                                    <div className="class-name">.flaticon-improve</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-js-file" />
                                    <div className="class-name">.flaticon-js-file</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-files" />
                                    <div className="class-name">.flaticon-files</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-css" />
                                    <div className="class-name">.flaticon-css</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-python" />
                                    <div className="class-name">.flaticon-python</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-html-file" />
                                    <div className="class-name">.flaticon-html-file</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-physics" />
                                    <div className="class-name">.flaticon-physics</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-web-plugin" />
                                    <div className="class-name">.flaticon-web-plugin</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-plugin" />
                                    <div className="class-name">.flaticon-plugin</div>
                                </div>
                                <div className="icon-font-block"><div className="flat-icon flaticon-web-plugin-1" />
                                    <div className="class-name">.flaticon-web-plugin-1</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default IconsPage;